import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Footer from '@components/Footer';
import Header from '@components/Header';
import Module from '@components/Module';
import Login from '@modules/login/Login';

import "bootstrap/dist/css/bootstrap.min.css";
import '@assets/css/main.css';

import { whiteLabel } from '@sm/config';

const logoutChannel = new BroadcastChannel('logout');

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [loggedAsUser, setLoggedAsUser] = useState(false);
  const [loggedAsUserEmail, setLoggedAsUserEmail] = useState('');

  const location = useLocation();
  const isOnReports = location.pathname === '/generate-reports';

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken) {
      setUserLoggedIn(true);
    }
    checkIfLoggedAsUser();

    window.addEventListener('message', (event) => {
      let eventData = event.data;
      if (typeof eventData === 'string' && eventData.includes('token')) {
        eventData = JSON.parse(eventData); 
      }
      if (event.origin === eventData.origin && event.isTrusted) {
        checkIfLoggedAsUser(eventData.token, eventData.email);
      }
    });

    setIsLoading(false);
  }, []);

  useEffect(() => {
    logoutChannel.onmessage = () => {
      logout();
      logoutChannel.close(); 
    };
  }, []);

  function checkIfLoggedAsUser(token, email) {
    const loggedAsToken = JSON.parse(localStorage.getItem('loginAsUser'));
    const loggedAsEmail = localStorage.getItem('loginAsUserEmail');
    const loginAsURLToken = token;
    const loginAsUserEmail = email;

    if (loginAsURLToken || loggedAsToken) {
      if (loginAsURLToken) {
        localStorage.setItem('loginAsUser', loginAsURLToken);
        localStorage.setItem('loginAsUserEmail', loginAsUserEmail);
      }
      setUserLoggedIn(true);
      if (loginAsURLToken || loggedAsToken) {
        setLoggedAsUser(true);
      }
      if (loginAsUserEmail || loggedAsEmail) {
        setLoggedAsUserEmail(loginAsUserEmail || loggedAsEmail);
      }
    } else {
      localStorage.removeItem('loginAsUser');
      localStorage.removeItem('loginAsUserEmail');
    }
  };

  function handleCloseLoginAsMode() {
    logout();
  };

  function logout() {
    logoutChannel.postMessage('Logout');
    localStorage.removeItem('loginAsUser');
    localStorage.removeItem('loginAsUserEmail');
    window.location.reload();
  };

  return (
    
    <div className={ `container content ${whiteLabel} ${userLoggedIn ? 'logged-in' : 'non-logged-in'} ${loggedAsUser ? 'view-only' : ''}` }>
      <div className='row'>
        <Header userLoggedIn={ userLoggedIn || loggedAsUser } />
        
        {!isLoading && (
          <>
            { userLoggedIn ?
              <Module />
              :
              <Login />
            }  
          </>
        )}
        {userLoggedIn && !isOnReports && <Footer /> }
      </div>

      {loggedAsUser && (
        <div className="logged-as-user">
          <h4 className="title"> You&apos;re now logged in as <span>{ loggedAsUserEmail }</span> </h4>
          <button
            className="close-btn"
            onClick={ () => handleCloseLoginAsMode() }
          >
            End session
          </button>
        </div>
      )}

    </div>
    
  );
};

export default App;